import { isEmptyObject } from '@sajari/react-sdk-utils';
import { EVENT_TRACKING_RESET } from '../../events.esm.js';
import { Listener } from '../Listener.esm.js';
import { PosNegLocalStorageManager } from '@sajari/sdk-js';

var events = [EVENT_TRACKING_RESET];
var Tracking = /*#__PURE__*/function () {
  function Tracking(field) {
    var _Object$entries;

    this.field = void 0;
    this.clientTracking = null;
    this.posNegLocalStorageManager = void 0;
    this.listeners = void 0;
    this.client = void 0;
    this.handleResultClicked = void 0;
    this.field = field;
    this.listeners = new Map(Object.entries((_Object$entries = {}, _Object$entries[EVENT_TRACKING_RESET] = new Listener(), _Object$entries)));
  }

  var _proto = Tracking.prototype;

  _proto.bootstrap = function bootstrap(client, handleResultClicked) {
    var _this$client, _this$posNegLocalStor;

    this.client = (_this$client = this.client) != null ? _this$client : client;
    this.handleResultClicked = handleResultClicked;
    this.posNegLocalStorageManager = (_this$posNegLocalStor = this.posNegLocalStorageManager) != null ? _this$posNegLocalStor : new PosNegLocalStorageManager(this.client);
  };

  _proto.listen = function listen(event, callback) {
    if (events.indexOf(event) === -1) {
      throw new Error("Unknown event type \"" + event + "\"");
    }

    return this.listeners.get(event).listen(callback);
  };

  _proto.emitTrackingReset = function emitTrackingReset(values) {
    this.listeners.get(EVENT_TRACKING_RESET).notify(function (listener) {
      listener(values);
    });
  };

  _proto.reset = function reset(variables) {
    this.clientTracking.reset();

    if (variables !== undefined) {
      this.emitTrackingReset(variables);
    }
  };

  _proto.next = function next(variables) {
    if (this.clientTracking === null) {
      throw new Error('clientTracking is null');
    }

    return this.clientTracking.next(variables);
  };

  _proto.getMetadata = function getMetadata() {
    var metadata = this.next({}).data;
    return !isEmptyObject(metadata) ? metadata : undefined;
  };

  _proto.onQueryResponse = function onQueryResponse(response) {};

  _proto.onResultClick = function onResultClick(values, token) {};

  _proto.onPromotionClick = function onPromotionClick(banner) {};

  _proto.onRedirect = function onRedirect(redirect) {};

  _proto.getResultHref = function getResultHref(_ref, token) {
    var url = _ref.url;
    return url;
  };

  return Tracking;
}();

export { Tracking };
//# sourceMappingURL=Tracking.esm.js.map
